<div class="flex flex-col h-full">

  <!-- Header: pin label + open-in-new-tab + link back to manage. -->
  <div class="flex-none flex items-center gap-3 px-4 py-2 border-b border-gray-200 dark:border-[#434863]">
    <h1 class="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-thumbtack text-app-teal-100 text-sm"></i>
      <span *ngIf="pin() as p">{{ p.label }}</span>
      <span *ngIf="!pin()" class="text-gray-500 dark:text-gray-400 text-sm font-normal">
        Pin not found — has it been removed?
      </span>
    </h1>
    <button
      *ngIf="pin() as p"
      class="dark-btn dark-btn-sm"
      (click)="openInNewTab()"
      title="Open in a new browser tab">
      <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>Open in new tab
    </button>
    <a class="dark-btn dark-btn-sm ml-auto" routerLink="/admin/pinned">
      <i class="fa-solid fa-gear mr-1"></i>Manage pins
    </a>
  </div>

  <!-- Iframe pane -->
  <div class="flex-1 relative min-h-0 bg-white dark:bg-app-black-200">
    <!-- Loading spinner overlay -->
    <div *ngIf="pin() && safeUrl() && !loaded() && !frameError()"
      class="absolute inset-0 flex items-center justify-center text-gray-500 dark:text-gray-400 pointer-events-none">
      <div class="text-center">
        <i class="fa-solid fa-spinner fa-spin text-2xl"></i>
        <div class="text-xs mt-2">Loading {{ pin()?.label }}…</div>
      </div>
    </div>

    <!-- Frame-refused hint. If the target sends X-Frame-Options: DENY or
         a restrictive CSP frame-ancestors, the iframe stays blank. We
         time out at 6s and surface this hint so the operator knows to
         use "Open in new tab" instead. -->
    <div *ngIf="pin() && frameError() && !loaded()"
      class="absolute inset-0 flex items-center justify-center bg-white dark:bg-app-black-200">
      <div class="text-center max-w-md p-6 border border-gray-200 dark:border-[#434863] rounded bg-gray-50 dark:bg-app-black-100">
        <i class="fa-solid fa-triangle-exclamation text-amber-500 dark:text-amber-300 text-2xl"></i>
        <h2 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">
          {{ pin()?.label }} refused to render in a frame
        </h2>
        <p class="mt-2 text-xs text-gray-600 dark:text-gray-300">
          The target site likely sets <code>X-Frame-Options: DENY</code> or a
          restrictive Content-Security-Policy. Use <strong>Open in new tab</strong>
          above instead — the URL is still valid.
        </p>
        <button class="dark-btn dark-btn-primary dark-btn-sm mt-4" (click)="openInNewTab()">
          <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>Open in new tab
        </button>
      </div>
    </div>

    <!-- Empty state — no pin matched the route key. -->
    <div *ngIf="!pin()"
      class="absolute inset-0 flex items-center justify-center text-gray-500 dark:text-gray-400">
      <div class="text-center max-w-md p-6">
        <i class="fa-solid fa-thumbtack-slash text-2xl"></i>
        <p class="mt-2 text-sm">Pin not found. It may have been removed.</p>
        <a class="dark-btn dark-btn-primary dark-btn-sm mt-4 inline-block" routerLink="/admin/pinned">
          Manage pins
        </a>
      </div>
    </div>

    <!-- The iframe itself. Referrerpolicy set to "no-referrer-when-downgrade"
         so upstream sees the referrer over HTTPS but not a mixed downgrade.
         Sandbox intentionally omitted — the target needs full JS + cookies
         + storage to render as a real app (tracker SPA, scanner pages). -->
    <iframe
      *ngIf="pin() && safeUrl()"
      [src]="safeUrl()"
      (load)="onIframeLoad()"
      class="w-full h-full border-0"
      referrerpolicy="no-referrer-when-downgrade"
      allow="clipboard-read; clipboard-write">
    </iframe>
  </div>
</div>
